export function getLink(id) {
  return `#item_${id}`;
}
